/**
 * DescriptionSynopsis component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled description synopsis component.
 */
const DescriptionSynopsis = styled.div<{
  maxLines?: number;
  limitWidth?: boolean;
  reduceSize?: boolean;
}>`
  color: ${Colors['light']};
  display: -webkit-box;
  font-family: ${Fonts['light']};
  font-size: ${(props) =>
    props.reduceSize
      ? `${30 * Screen.widthRatio}px`
      : `${32 * Screen.widthRatio}px`};
  line-height: ${40 * Screen.widthRatio}px;
  max-height: ${120 * Screen.widthRatio}px;
  overflow: hidden;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.8);
  width: ${(props) =>
    props.limitWidth
      ? `${730 * Screen.widthRatio}px`
      : `${950 * Screen.widthRatio}px`};
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(props) => props.maxLines || 3};
`;

export default DescriptionSynopsis;
